module.exports = "<span>{{ $time | async | date: 'dd/MM/yyyy - HH:mm:ss' }}</span>"